module.exports = __webpack_public_path__ + "static/media/gn.5ab79ace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gn.svg
// module id = 131
// module chunks = 0